import { Button } from "../components";
import { ReactComponent as Error } from "../assets/icons/exclamation.svg";
import { ReactComponent as Info } from "../assets/icons/info.svg";
import React from "react";
import { ReactComponent as Success } from "../assets/icons/check.svg";
import cn from "classnames";
import sharedStyles from "../shared.module.scss";
import styles from "./StatusPage.module.scss";
import { useFormatMessage } from "../i18n";
import { useHistory } from "react-router-dom";
import { useScrollToTop } from "../hooks";

export function StatusPage({
  className,
  variant,
  text,
  buttonTitle,
  nextPage = "/",
}) {
  const tr = useFormatMessage();
  const history = useHistory();
  useScrollToTop([]);

  function handleCancelClick() {
    history.push(nextPage);
  }

  const variants = {
    success: <Success />,
    error: <Error />,
    info: <Info />,
  };

  if (!variant) return null;
  return (
    <div className={cn(className, styles.statusPage)}>
      {variants[variant]}
      <p className={cn(styles.text, sharedStyles.mainText)}>{text}</p>
      <Button
        type="button"
        title={tr(buttonTitle)}
        variant="light"
        size="sm"
        onClick={handleCancelClick}
      />
    </div>
  );
}
